import api from '@/helpers/api_helper';
import { apiUrls } from '@/constant/configure';
import type {
    InstagramConnectResponse,
    InstagramConnectionDto,
    InstagramMediaBatchDto,
    InstagramMediaListDto,
} from '@/types/instagram';

const studio = { baseURL: apiUrls.studio };
const PREFIX = '/api/v1';

export const getInstagramStatus = async (withProfile = false): Promise<InstagramConnectionDto> => {
    const res = await api.get<InstagramConnectionDto>(`${PREFIX}/instagram/status`, {
        ...studio,
        params: withProfile ? { withProfile: true } : undefined,
    });
    return res.data;
};

export const postInstagramConnect = async (): Promise<InstagramConnectResponse> => {
    const res = await api.post<InstagramConnectResponse>(`${PREFIX}/instagram/connect`, undefined, studio);
    return res.data;
};

export const deleteInstagramDisconnect = async (): Promise<void> => {
    await api.delete(`${PREFIX}/instagram/disconnect`, studio);
};

export const getInstagramMedia = async (params: {
    limit?: number;
    after?: string | null;
}): Promise<InstagramMediaListDto> => {
    const res = await api.get<InstagramMediaListDto>(`${PREFIX}/instagram/media`, {
        ...studio,
        params: {
            limit: params.limit ?? 25,
            ...(params.after ? { after: params.after } : {}),
        },
    });
    return res.data;
};

export const getInstagramMediaByIds = async (ids: string[]): Promise<InstagramMediaBatchDto> => {
    const res = await api.get<InstagramMediaBatchDto>(`${PREFIX}/instagram/media/by-ids`, {
        ...studio,
        params: { ids: ids.join(',') },
    });
    return res.data;
};
